// extracted by mini-css-extract-plugin
export default {"tooltip-container":"Tooltip_tooltip-container__Omsm6","tooltip":"Tooltip_tooltip__CApMv","fadeout":"Tooltip_fadeout__6vCfW"};